// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__XaNpj","logo":"Header_logo__1FRrW","socialMedia":"Header_socialMedia__CYwfz","button":"Header_button__hnRqq"};